'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

AggregateStatisticsSummaryDirective=class AggregateStatisticsSummaryDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['statisticsViewModel','selectedNotificationType'];
}

get templateUrl(){
return'/templates/directives/aggregateStatisticsSummaryDirective/aggregateStatisticsSummaryTemplate';
}

get controller(){
return AggregateStatisticsSummaryController;
}};let


AggregateStatisticsSummaryController=class AggregateStatisticsSummaryController{
static get $inject(){
return['$scope'];
}

constructor($scope){
this._$scope=$scope;
}};



module.exports=AggregateStatisticsSummaryDirective;
//# sourceMappingURL=aggregateStatisticsSummaryDirective.js.map
